module.exports = __webpack_public_path__ + "img/employe.58a6f55b.jpg";